<template>
  <div class="cis-ux-example">
    <sc-placeholder name="jss-cis-ux-example" :rendering="rendering" />
    <main role="main">
      <section id="text">
        <article id="text__fonts">
          <header><h2>Fonts</h2></header>
          <div class="fonts">
            <div class="font-box" style="font-family: acumin-pro, sans-serif">
              @include font-styles(acumin-pro, 2rem, 100, normal, 2rem, 0, #000);
            </div>
            <div style="font-family: acumin-pro-semi-condensed, sans-serif">
              @include font-styles(acumin-pro-semi-condensed, 2rem, 100, normal, 2rem, 0, #000);
            </div>
          </div>
        </article>
        <article id="text__headings">
          <header><h2>Headings</h2></header>
          <div>
            <h1>Heading 1</h1>
            <h2>Heading 2</h2>
            <h3>Heading 3</h3>
            <h4>Heading 4</h4>
            <pre>“Acumin Pro Extra Light“ <span style="font-size: 2.5rem">&#8673;</span>
font-family: acumin-pro, sans-serif;
font-style: normal;
font-weight: 200;</pre>

            <pre>
“Acumin Pro Medium” <span style="font-size: 2.5rem">&#8675;</span>
font-family: acumin-pro, sans-serif;
font-style: normal;
font-weight: 500;</pre>
            <h5>Heading 5</h5>
          </div>
        </article>
        <br />
        <article id="color__swatches">
          <header><h2>Colors</h2></header>
          <div class="color-swatches">
            <div class="swatch-box">
              <p>Blue:</p>
              <div class="swatch blue">#0086BF</div>
            </div>
            <div class="swatch-box">
              <p>Dark Blue:</p>
              <div class="swatch dark-blue">#003B5C</div>
            </div>
          </div>
          <div class="color-swatches">
            <div class="swatch-box">
              <p>Orange:</p>
              <div class="swatch orange">#D56C00</div>
            </div>
            <div class="swatch-box">
              <p>Alert:</p>
              <div class="swatch alert">#FFDC00</div>
            </div>
          </div>
        </article>
        <article id="cta__examples">
          <header><h2>CTAs</h2></header>
          <div class="flex-container">
            <div>
              <a href="" class="c-cta--primary">Primary CTA</a>
            </div>
            <div>
              <a href="" class="c-cta--secondary">Secondary CTA</a>
            </div>
            <div>
              <a href="" class="c-cta--tertiary">Tertiary CTA</a>
            </div>
          </div>
          <pre>
“Acumin Pro Condensed Semibold”
font-family: acumin-pro-condensed, sans-serif;
font-style: normal;
font-weight: 600;</pre
          >
        </article>
        <article id="text__paragraphs">
          <header><h2>Paragraphs</h2></header>
          <div>
            <p>
              A paragraph (from the Greek paragraphos, “to write beside” or “written beside”) is a
              self-contained unit of a discourse in writing dealing with a particular point or idea.
              A paragraph consists of one or more sentences. Though not required by the syntax of
              any language, paragraphs are usually an expected part of formal writing, used to
              organize longer prose.
            </p>
            <p>
              A paragraph (from the Greek paragraphos, “to write beside” or “written beside”) is a
              self-contained unit of a discourse in writing dealing with a particular point or idea.
              A paragraph consists of one or more sentences. Though not required by the syntax of
              any language, paragraphs are usually an expected part of formal writing, used to
              organize longer <a href="#!">prose</a>.
            </p>
            <pre>
“Acumin Pro Extra Light“
font-family: acumin-pro, sans-serif;
font-style: normal;
font-weight: 200;</pre
            >
          </div>
        </article>
        <article id="text__blockquotes">
          <header><h2>Blockquotes</h2></header>
          <div>
            <blockquote>
              <p>
                A block quotation (also known as a long quotation or extract) is a quotation in a
                written document, that is set off from the main text as a paragraph, or block of
                text.
              </p>
              <p>
                It is typically distinguished visually using indentation and a different typeface or
                smaller size quotation. It may or may not include a citation, usually placed at the
                bottom.
              </p>
              <cite><a href="#!">Said no one, ever.</a></cite>
            </blockquote>
          </div>
        </article>
        <article id="Labels">
          <header><h2>Labels</h2></header>
          <div>
            <div class="c-header-utility__item c-alert">
              <div class="c-alert__title c-alert__level--green">
                Alert Level: <span class="c-alert__option">Low</span
                ><span class="c-alert__button"></span>
              </div>
            </div>
          </div>
          <br />
          <div class="c-header-utility__item c-alert">
            <div class="c-alert__title c-alert__level--blue">
              Alert Level: <span class="c-alert__option"> Guarded </span
              ><span class="c-alert__button"></span>
            </div>
          </div>
          <br />
          <div>
            <div class="c-header-utility__item c-alert">
              <div class="c-alert__title c-alert__level--yellow">
                Alert Level: <span class="c-alert__option"> Elevated </span
                ><span class="c-alert__button"></span>
              </div>
            </div>
          </div>
          <br />
          <div>
            <div class="c-header-utility__item c-alert">
              <div class="c-alert__title c-alert__level--orange">
                Alert Level: <span class="c-alert__option"> High </span
                ><span class="c-alert__button"></span>
              </div>
            </div>
          </div>
          <br />
          <div>
            <div class="c-header-utility__item c-alert">
              <div class="c-alert__title c-alert__level--red">
                Alert Level: <span class="c-alert__option"> Severe </span
                ><span class="c-alert__button"></span>
              </div>
            </div>
          </div>
        </article>
        <br />
        <article id="text__lists">
          <header><h2>Lists</h2></header>
          <div>
            <h3>Definition list</h3>
            <dl>
              <dt>Definition List Title</dt>
              <dd>This is a definition list division.</dd>
            </dl>
            <h3>Ordered List</h3>
            <ol>
              <li>List Item 1</li>
              <li>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent scelerisque tempus
                ex laoreet pharetra. Cras in orci pretium, bibendum felis vitae, convallis est.
                Aenean blandit enim in libero tempus vulputate. Sed sit amet blandit metus.
                Suspendisse at eleifend odio.
              </li>
              <li>List Item 3</li>
              <li>List Item 4</li>
            </ol>
            <h3>Unordered List</h3>
            <ul>
              <li>List Item 1</li>
              <li>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent scelerisque tempus
                ex laoreet pharetra. Cras in orci pretium, bibendum felis vitae, convallis est.
                Aenean blandit enim in libero tempus vulputate. Sed sit amet blandit metus.
                Suspendisse at eleifend odio.
              </li>
              <li>List Item 3</li>
              <li>List Item 4</li>
              <ul>
                <li>Nested once</li>
                <ul>
                  <li>Nested twice</li>
                  <ul>
                    <li>Nested three times</li>
                  </ul>
                </ul>
              </ul>
            </ul>
          </div>
        </article>
        <article id="text__hr">
          <header><h2>Horizontal rules</h2></header>
          <div>
            <hr />
          </div>
        </article>
        <article id="text__tables">
          <header><h2>Tabular data</h2></header>
          <table>
            <caption>
              Table Caption
            </caption>
            <thead>
              <tr>
                <th>Table Heading 1</th>
                <th>Table Heading 2</th>
                <th>Table Heading 3</th>
                <th>Table Heading 4</th>
                <th>Table Heading 5</th>
              </tr>
            </thead>
            <tfoot>
              <tr>
                <th>Table Footer 1</th>
                <th>Table Footer 2</th>
                <th>Table Footer 3</th>
                <th>Table Footer 4</th>
                <th>Table Footer 5</th>
              </tr>
            </tfoot>
            <tbody>
              <tr>
                <td>Table Cell 1</td>
                <td>Table Cell 2</td>
                <td>Table Cell 3</td>
                <td>Table Cell 4</td>
                <td>Table Cell 5</td>
              </tr>
              <tr>
                <td>Table Cell 1</td>
                <td>Table Cell 2</td>
                <td>Table Cell 3</td>
                <td>Table Cell 4</td>
                <td>Table Cell 5</td>
              </tr>
              <tr>
                <td>Table Cell 1</td>
                <td>Table Cell 2</td>
                <td>Table Cell 3</td>
                <td>Table Cell 4</td>
                <td>Table Cell 5</td>
              </tr>
              <tr>
                <td>Table Cell 1</td>
                <td>Table Cell 2</td>
                <td>Table Cell 3</td>
                <td>Table Cell 4</td>
                <td>Table Cell 5</td>
              </tr>
            </tbody>
          </table>
        </article>
        <article id="text__code">
          <header><h2>Code</h2></header>
          <div>
            <p><strong>Keyboard input:</strong> <kbd>Cmd</kbd></p>
            <p><strong>Inline code:</strong> <code>&lt;div&gt;code&lt;/div&gt;</code></p>
            <p>
              <strong>Sample output:</strong>
              <samp>This is sample output from a computer program.</samp>
            </p>
            <h2>Pre-formatted text</h2>
            <pre>
              P R E F O R M A T T E D T E X T
              ! " # $ % &amp; ' ( ) * + , - . / \
              0 1 2 3 4 5 6 7 8 9 : ; &lt; = &gt; ?
              @ A B C D E F G H I J K L M N O
              P Q R S T U V W X Y Z [ \ ] ^ _
              ` a b c d e f g h i j k l m n o
              p q r s t u v w x y z { | } ~ &
            </pre>
          </div>
        </article>
        <article id="text__inline">
          <header><h2>Inline elements</h2></header>
          <div>
            <p><a href="#!">This is a text link</a>.</p>
            <p><strong>Strong is used to indicate strong importance.</strong></p>
            <p><em>This text has added emphasis.</em></p>
            <p>
              The <u>u element</u> is text with an unarticulated, though explicitly rendered,
              non-textual annotation.
            </p>
            <p><del>This text is deleted</del> and <ins>This text is inserted</ins>.</p>
            <p><s>This text has a strikethrough</s>.</p>
            <p>Superscript<sup>®</sup>.</p>
            <p>Subscript for things like H<sub>2</sub>O.</p>
            <p><small>This small text is small for for fine print, etc.</small></p>
            <p>Abbreviation: <abbr title="HyperText Markup Language">HTML</abbr></p>
            <p>
              <q cite="https://developer.mozilla.org/en-US/docs/HTML/Element/q"
                >This text is a short inline quotation.</q
              >
            </p>
            <p><cite>This is a citation.</cite></p>
            <p>The <dfn>dfn element</dfn> indicates a definition.</p>
            <p>The <mark>mark element</mark> indicates a highlight.</p>
            <p>The <var>variable element</var>, such as <var>x</var> = <var>y</var>.</p>
            <p>The time element: <time datetime="2013-04-06T12:32+00:00">2 weeks ago</time></p>
          </div>
        </article>
      </section>
      <section id="forms">
        <article id="form-elements">
          <header><h2>Form elements</h2></header>
          <form>
            <fieldset id="forms__input">
              <legend>Input fields</legend>
              <p>
                <label for="input__text">Text Input</label>&nbsp;
                <input id="input__text" type="text" placeholder="Text Input" />
              </p>
              <p>
                <label for="input__password">Password</label>&nbsp;
                <input id="input__password" type="password" placeholder="Type your Password" />
              </p>
              <p>
                <label for="input__webaddress">Web Address</label>&nbsp;
                <input id="input__webaddress" type="url" placeholder="http://yoursite.com" />
              </p>
              <p>
                <label for="input__emailaddress">Email Address</label>&nbsp;
                <input id="input__emailaddress" type="email" placeholder="name@email.com" />
              </p>
              <p>
                <label for="input__phone">Phone Number</label>&nbsp;
                <input id="input__phone" type="tel" placeholder="(999) 999-9999" />
              </p>
              <p>
                <label for="input__search">Search</label>&nbsp;
                <input id="input__search" type="search" placeholder="Enter Search Term" />
              </p>
              <p>
                <label for="input__text2">Number Input</label>&nbsp;
                <input id="input__text2" type="number" placeholder="Enter a Number" />
              </p>
              <p>
                <label for="input__text3" class="error">Error</label>&nbsp;
                <input id="input__text3" class="is-error" type="text" placeholder="Text Input" />
              </p>
              <p>
                <label for="input__text4" class="valid">Valid</label>&nbsp;
                <input id="input__text4" class="is-valid" type="text" placeholder="Text Input" />
              </p>
            </fieldset>

            <fieldset id="forms__select">
              <legend>Select menus</legend>
              <p>
                <label for="select">Select</label>&nbsp;
                <select id="select">
                  <optgroup label="Option Group">
                    <option>Option One</option>
                    <option>Option Two</option>
                    <option>Option Three</option>
                  </optgroup>
                </select>
              </p>
            </fieldset>

            <fieldset id="forms__checkbox">
              <legend>Checkboxes</legend>
              <ul class="list list--bare">
                <li>
                  <label for="checkbox1"
                    ><input id="checkbox1" name="checkbox" type="checkbox" checked="checked" />
                    Choice A</label
                  >
                </li>
                <li>
                  <label for="checkbox2"
                    ><input id="checkbox2" name="checkbox" type="checkbox" /> Choice B</label
                  >
                </li>
                <li>
                  <label for="checkbox3"
                    ><input id="checkbox3" name="checkbox" type="checkbox" /> Choice C</label
                  >
                </li>
              </ul>
            </fieldset>

            <fieldset id="forms__radio">
              <legend>Radio buttons</legend>
              <ul class="list list--bare">
                <li>
                  <label for="radio1"
                    ><input id="radio1" name="radio" type="radio" class="radio" checked="checked" />
                    Option 1</label
                  >
                </li>
                <li>
                  <label for="radio2"
                    ><input id="radio2" name="radio" type="radio" class="radio" /> Option 2</label
                  >
                </li>
                <li>
                  <label for="radio3"
                    ><input id="radio3" name="radio" type="radio" class="radio" /> Option 3</label
                  >
                </li>
              </ul>
            </fieldset>

            <fieldset id="forms__textareas">
              <legend>Textareas</legend>
              <p>
                <label for="textarea">Textarea</label>
                <br />
                <textarea
                  id="textarea"
                  rows="8"
                  cols="48"
                  placeholder="Enter your message here"
                ></textarea>
              </p>
            </fieldset>
            <fieldset id="forms__html5">
              <legend>HTML5 inputs</legend>
              <p>
                <label for="ic">Color input</label>
                <input type="color" id="ic" value="#000000" />
              </p>
              <p>
                <label for="in">Number input</label>
                <input type="number" id="in" min="0" max="10" value="5" />
              </p>
              <p>
                <label for="ir">Range input</label>
                <input type="range" id="ir" value="10" />
              </p>
              <p>
                <label for="idd">Date input</label>
                <input type="date" id="idd" value="1970-01-01" />
              </p>
            </fieldset>

            <fieldset id="forms__action">
              <legend>Action buttons</legend>
              <p>
                Input Tags<br />
                <input type="submit" value="submit" />
                <input type="button" value="button" />
                <input type="reset" value="reset" />
                <input type="submit" value="disabled" disabled />
              </p>
              <p>
                Button Tags<br />
                <button type="submit">submit</button>
                <button type="button">button</button>
                <button type="reset">reset</button>
                <button type="button" disabled>disabled</button>
              </p>
            </fieldset>
          </form>
        </article>
      </section>
    </main>
  </div>
</template>

<style lang="scss" scoped>
article {
  padding-top: 15px;
  border-top: 1px solid #eee;
  margin-bottom: 15px;

  .fonts {
    .font-box {
      font-size: 2rem;
      font-weight: 100;
      font-style: normal;
      line-height: 2rem;
      letter-spacing: 0;
      color: #000;
    }
  }
  .color-swatches {
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
    margin: 0;
  }
  .swatch-box {
    flex: 0 1 350px;
    padding: 0 1em;
  }
  .swatch {
    text-align: center;
    position: relative;
    padding: 1em;
    color: $white;
    font-weight: bold;
    margin: auto;
    text-shadow: 1px 1px 1px rgb(0 0 0 / 15%);
    &.orange {
      background: $orange;
    }
    &.alert {
      background: $alert-yellow;
      color: $dark-blue;
    }
    &.dark-blue {
      background: $dark-blue;
    }
    &.blue {
      background: $blue;
    }
  }
}

article {
  padding: 2rem;
  margin-bottom: 2rem;
  border-bottom: 1px solid $box-gray;
  box-shadow: 0 0.3rem 0.7rem 0 rgb(0 0 0 / 5%), 0 1.8rem 1.7rem 0 rgb(0 0 0 / 5%);
  background: $white;
  .flex-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    align-items: center;
    @include tablet-down {
      flex-direction: column;
    }
    div {
      flex: 0 1 auto;
      padding: 1rem;
    }
  }
}
</style>

<script>
import { Placeholder } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-UX-Example',
  props: {
    rendering: {
      type: Object
    }
  },
  components: {
    ScPlaceholder: Placeholder
  }
};
</script>
